import {
  SHOW_SIDEBAR,
  CHANGE_ACTIVED_PAGE,
  SHOW_MESSAGE_BOX,
  SELECTED_TP_CHANGED,
  SHOW_LOADING_BOX,
  HIDE_LOADING_BOX,
} from '../actions/system.actions'
import { getTps } from '../../services/localstorage/localstorage.service'

const initialSystenState = {
  showSidebar: false,
  activedPage: 'Home',
  messageBox: {
    msgOK: null,
    msgNOK: null,
    showCopyButton: false,
  },
  loadingBox: {
    message: null,
    title: null,
  },
  selectedTp: getTps().length === 0 ? '' : getTps()[0].id,
}

export default function (state = initialSystenState, action) {
  switch (action.type) {
    case SHOW_SIDEBAR:
      return {
        ...state,
        showSidebar: action.show,
      }
    case CHANGE_ACTIVED_PAGE:
      return {
        ...state,
        activedPage: action.newPage,
      }
    case SHOW_MESSAGE_BOX:
      return {
        ...state,
        messageBox: {
          msgOK: action.msgOK,
          msgNOK: action.msgNOK,
          showCopyButton: action.showCopyButton,
        },
      }
    case SHOW_LOADING_BOX:
      return {
        ...state,
        loadingBox: {
          message: action.message,
          title: action.title,
        },
        showLoadingBox: true,
      }
    case HIDE_LOADING_BOX:
      return {
        ...state,
        showLoadingBox: false,
      }
    case SELECTED_TP_CHANGED:
      return {
        ...state,
        selectedTp: action.tpId,
      }
    default:
      return state
  }
}
